// extracted by mini-css-extract-plugin
module.exports = {"bookmark":"Bookmark-module--bookmark--2eHrZ","active":"Bookmark-module--active--1IraG"};